module.exports = __webpack_public_path__ + "static/img/1017_big.64ce8ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1017_big.png
// module id = UMXe
// module chunks = 1